<template>
    <div>
        <table class="table table-hover" v-bind:id="id"  width="100%">
          <thead> </thead>
          <tbody> </tbody>
        </table>
    </div>
  </template>
  <script>
    export default {
      name:"TableLicenciaAlcoholes",
      props: {id:'',data_:[],lengthMenu:[]},
      mounted () {
        //$('#'+this.id).DataTable();
        //TableManaged2.init2();
        this.createTable();
        window.elimadosAlcoholes = this;
      },      
      methods:{
        accionDetalle(dato){
          this.$emit('detalle', dato);
        },
        createTable(){
          $('#' + this.id).DataTable( {
            "data": this.data_,
            "columns": [
              {"data": "folio_id","title":"Folio ID"},
              {"data": "licencia","title":"Licencia"},
              {"data":"rfc","title":"RFC"},
              {"data": "nombre_comercial","title":"Nombre Comercial"},
              
              {"data":"municipio","title":"Municipio"},
              {"data":"ano_a_cobrar","title":"Año"},
              {"data":"estatus","title":"Estatus",
                "render": this.spanEstatus
              }, 
              {"data":"derecho","title":"Derecho"},
              {"data":"fecha_de_vencimiento","title":"Fecha de vencimiento"},
              {"data":"actualizacion","title":"Folio ID"},
              {"data":"recargos","title":"Recargos"},
              {"data":"sancion","title":"Sanción"},
              {"data":"total","title":"Total"},
              {"title":"Estatus bitacora","render": this.spanEstatusBitacora},
              {"render": this.btnDetalle },       
            ]
          });
        },
        btnDetalle( data, type, row, meta){
          return "<a class='btn btn-icon-only btn-circle green' data-toggle='modal' href='#portlet-edit' title='Detalle Registro'  onclick='accionDetalle("+JSON.stringify(row)+")'><i class='fa fa-list'></i></a>";
        },
        spanEstatus( data, type, row, meta){
          let status=row.estatus==='VIGENTE' ? 'btn-success' : row.estatus==='REFERENCIA ACTIVA' ? 'btn-warning' : row.estatus==='PAGADO' ? 'label-default' : 'label-danger'
          return '<span class="label  btn-circle '+status+'" class="">'+row.estatus+' </span>';
        },
        spanEstatusBitacora( data, type, row, meta){
          return '<span class="label  btn-circle btn-danger" class="">'+row.estatus_descripcion+' </span>';
        }
      }   
    }
  </script>